<div class="d3-chart" #chart>
</div>
